import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { templatesEditService } from '../services/templatesEdit.service';
import type { TemplateRecord } from '../../list/types/templates.types';

export function useTemplatesEdit(id: string) {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [formData, setFormData] = useState<Partial<TemplateRecord>>({});

  const { data: template, isLoading } = useQuery({
    queryKey: ['settings', 'templates', 'detail', id],
    queryFn: () => templatesEditService.getTemplate(id),
    enabled: !!id,
  });

  useEffect(() => {
    if (template) {
      setFormData(template);
    }
  }, [template]);

  const mutation = useMutation({
    mutationFn: (data: Partial<TemplateRecord>) => templatesEditService.updateTemplate(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['settings', 'templates'] });
      toast.success('Đã cập nhật mẫu tài liệu');
      navigate('/settings/templates');
    },
    onError: (error: any) => {
      toast.error(error.message || 'Không thể cập nhật mẫu tài liệu');
    }
  });

  return {
    formData,
    setFormData,
    isLoading,
    isSaving: mutation.isPending,
    updateTemplate: () => mutation.mutate(formData),
  };
}
